{
  "title": "roster 명부",
  "displayRule": "아군 줄에는 닉네임과 게임 ID와 행군 시간이, 적군 줄에는 닉네임과 행군 시간이 보입니다. 게임 ID는 이 화면에서만 보이고 연맹원 화면에는 나가지 않습니다.",
  "marchingOnlyHere": "행군 시간을 고치는 자리는 이 명부 하나뿐입니다. rally 편집기에서는 고칠 수 없습니다.",
  "nextSeedAlly": "아군부터 올립니다. 게임 ID, 닉네임, 행군을 넣습니다",
  "nextGoAttack": "ATTACK 탭에서 main 을 만듭니다",
  "nextOpsInAttack": "진행 중인 ops 는 ATTACK 탭에 있습니다",
  "operationDispatched": "confirm 한 ops 가 진행 중입니다. 여기서 고친 행군은 그 ops 를 움직이지 않습니다. 다시 잡을 때 반영됩니다.",
  "operationAssembling": "조립 중인 ops 가 있습니다. 여기서 고친 행군이 그 ops 에 곧바로 반영됩니다.",
  "allyTitle": "아군",
  "allyWhy": "아군 명부는 whitelist 명단 그 자체입니다. 여기 없는 게임 ID는 코드를 알아도 들어오지 못합니다.",
  "allyGameId": "게임 ID",
  "allyGameIdHint": "숫자만 넣습니다 (예: 131952426)",
  "allyNickname": "닉네임",
  "allyMarching": "행군 시간",
  "allyAdd": "등록",
  "allyEmpty": "아직 등록된 아군이 없습니다",
  "allyMarchingNote": "행군 시간은 새로 올리는 사람에게 적용됩니다. 이미 명부에 있는 사람은 아래 목록에서 고칩니다.",
  "allyNewOnly": "등록은 새 사람만 올립니다. 이름을 고치거나 지우는 것은 아래 목록의 그 줄에서 합니다.",
  "allyGameIdTypo": "게임 ID를 잘못 넣었으면 그 줄을 지우고 다시 등록합니다. 게임 ID는 줄에서 고칠 수 없습니다.",
  "allyAdded": "명부에 올렸습니다: {new}",
  "enemyTitle": "적군",
  "enemyWhy": "행군 시간을 아직 못 쟀어도 닉네임만으로 등록합니다. 그 적의 rally 는 착탄 미상으로 뜹니다.",
  "enemyNickname": "닉네임",
  "enemyMarching": "행군 시간 (없으면 비워 둡니다)",
  "enemyAdd": "등록",
  "enemyEmpty": "아직 등록된 적이 없습니다",
  "enemyDuplicateNote": "같은 닉네임을 다시 등록해도 새 줄이 생기지 않습니다.",
  "enemyAdded": "적 명부에 올렸습니다: {new}",
  "enemyExisting": "이미 적 명부에 있습니다: {new}. 행군 시간은 목록에서 고칩니다.",
  "columnNickname": "닉네임",
  "columnMarching": "행군",
  "needsInput": "입력필요",
  "reading": "명부를 읽는 중입니다",
  "marchingPlaceholder": "4:00",
  "marchingHelp": "비우고 저장하면 「입력필요」로 돌아갑니다.",
  "save": "저장",
  "cancel": "취소",
  "rename": "이름 수정",
  "renameLabel": "새 이름",
  "renamed": "이름을 고쳤습니다: {old} → {new}. 행군 시간은 그대로입니다.",
  "remove": "삭제",
  "removeConfirmAlly": "지우면 {name}{topic} 명단에서 내려갑니다. 지금 그 사람 화면이 열려 있다면 함께 끊깁니다. 행군 {value}도 함께 사라집니다. 한 번 더 누르면 지웁니다.",
  "removeConfirmAllyBlank": "지우면 {name}{topic} 명단에서 내려갑니다. 지금 그 사람 화면이 열려 있다면 함께 끊깁니다. 한 번 더 누르면 지웁니다.",
  "removeConfirmEnemy": "지우면 {name}의 누적 행군({value})도 함께 사라집니다. 되돌릴 수 없습니다. 한 번 더 누르면 지웁니다.",
  "removeConfirmEnemyBlank": "지우면 {name}{subject} 명부에서 사라집니다. 되돌릴 수 없습니다. 한 번 더 누르면 지웁니다.",
  "removed": "지웠습니다: {name}",
  "marchingSaved": "저장했습니다: {value}",
  "marchingCleared": "비웠습니다. 입력필요로 돌아갑니다.",
  "savedWhileDispatched": "진행 중인 ops 는 그대로입니다.",
  "savedWhileAssembling": "조립 중인 ops 에 반영했습니다.",
  "clearedWhileAssembling": "행군이 비었으므로 이 사람의 줄은 조립 중인 ops 에서 빠집니다.",
  "badTime": "시간 형식이 아닙니다. 4:00 또는 3:59.5 처럼 씁니다.",
  "needNickname": "닉네임을 넣어 주세요.",
  "needGameId": "게임 ID를 넣어 주세요."
}
